// Exports
// -------

export default function scrollContentIntoView(inDialog, targetSelector = '.main') {
  const selector = inDialog ? '.mdc-dialog__content > *:first-child' : targetSelector;
  const element = document.querySelector(selector);

  if (!element) {
    return;
  }

  if (inDialog || window.scrollY > element.offsetTop) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
}
